import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function CourseCatalog() {
  const { user } = useAuth();
  const [courses, setCourses] = useState([]);
  const paid = !!user && user.plan && user.plan !== "free";

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/courses");
      setCourses(data);
    })();
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-7xl" data-testid="course-catalog-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Curriculum</div>
      <h1 className="font-display text-4xl font-bold tracking-tight text-slate-950 mt-1">All modules</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">
        Eight modules. Each covers field-ready knowledge, with a final certification quiz. Score 75% or higher to mark a module passed.
      </p>

      {!paid && (
        <div className="mt-6 inline-flex items-center gap-3 border border-orange-200 bg-orange-50 px-4 py-3 rounded-sm">
          <Lock className="w-4 h-4 text-orange-600" />
          <div className="text-sm text-slate-800">
            <strong>2 of 8 modules</strong> are free preview. <Link to="/pricing" className="font-semibold text-orange-700 hover:underline">See plans</Link> to unlock the rest.
          </div>
        </div>
      )}

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map((c) => {
          const locked = !paid && !c.is_preview;
          return (
            <Link
              key={c.course_id}
              to={`/courses/${c.course_id}`}
              data-testid={`catalog-card-${c.slug}`}
              className="border border-slate-200 rounded-sm overflow-hidden bg-white hover:-translate-y-1 hover:shadow-md transition-all relative"
            >
              <div className="aspect-[16/9] bg-slate-100 relative">
                {c.thumbnail && <img src={c.thumbnail} alt="" className={`w-full h-full object-cover ${locked ? "grayscale" : ""}`} />}
                {locked && (
                  <div className="absolute top-3 right-3 bg-slate-950 text-white text-xs font-bold uppercase tracking-[0.15em] px-2 py-1 rounded-sm inline-flex items-center gap-1">
                    <Lock className="w-3 h-3" /> Locked
                  </div>
                )}
                {c.is_preview && !paid && (
                  <div className="absolute top-3 left-3 bg-orange-600 text-white text-xs font-bold uppercase tracking-[0.15em] px-2 py-1 rounded-sm">
                    Free preview
                  </div>
                )}
              </div>
              <div className="p-5">
                <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">
                  Module {String(c.order).padStart(2, "0")}
                </div>
                <div className="font-display font-bold text-slate-950 text-lg mt-2">{c.title}</div>
                <div className="text-sm text-slate-600 mt-2 line-clamp-3">{c.description}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
